module.exports = __webpack_public_path__ + "assets/9e4c8569c94a842a82b3d32ad3fa006d.mp3";